export default __webpack_public_path__ + "static/media/Link.8f1d9c1d.svg";